export default "__VITE_ASSET__aJqYoP2C__"